var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPuzzle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1071_2932)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1071_2932",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 37,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9214 0H0.921387V36H36.9214V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1071_2932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8379 17.3182H31.7635C31.436 17.3182 31.1706 17.0528 31.1706 16.7252L31.1692 8.68735C31.1692 8.35982 30.9038 8.09441 30.5762 8.09441L23.5958 8.09582C23.2682 8.09582 23.0028 7.83041 23.0028 7.50288V6.42853C23.0021 4.17323 21.1739 2.3457 18.9186 2.3457C16.6647 2.3457 14.8365 4.17394 14.8365 6.42782V7.50359C14.8365 7.83112 14.571 8.09653 14.2435 8.09653L7.26304 8.09794C6.93551 8.09794 6.6701 8.36335 6.6701 8.69088L6.67151 16.7288C6.67151 17.0563 6.4061 17.3217 6.07857 17.3217H5.00421C2.74892 17.3224 0.921387 19.1506 0.921387 21.4059C0.921387 23.6605 2.75033 25.4888 5.00492 25.4881H6.07927C6.4068 25.4881 6.67221 25.7535 6.67221 26.081L6.67363 33.0615C6.67363 33.389 6.93904 33.6544 7.26657 33.6544L14.247 33.653C14.5746 33.653 14.84 33.3876 14.84 33.0601V33.0586C14.84 30.8104 16.664 28.9765 18.9221 28.9765C21.1767 28.9758 23.0056 30.8055 23.0063 33.0586C23.0063 33.3861 23.2718 33.6523 23.5993 33.6523L30.5798 33.6508C30.9073 33.6508 31.1727 33.3854 31.1727 33.0579L31.1713 26.0774C31.1713 25.7499 31.4367 25.4845 31.7642 25.4845H32.8386C35.0939 25.4837 36.9214 23.6555 36.9214 21.4002C36.9214 19.1457 35.0925 17.3175 32.8379 17.3182ZM19.9795 24.3078C19.9795 24.8923 19.5059 25.3666 18.9207 25.3666C18.3362 25.3666 17.8619 24.8923 17.8619 24.3078V24.2189C17.8619 23.6344 18.3362 23.1601 18.9207 23.1601C19.5059 23.1601 19.9795 23.6344 19.9795 24.2189V24.3078ZM20.0762 19.5579C20.0183 19.5763 19.9795 19.625 19.9795 19.6786V20.5638C19.9795 21.149 19.5059 21.6226 18.9207 21.6226C18.3362 21.6226 17.8619 21.149 17.8619 20.5638V19.6786C17.8619 18.7137 18.4816 17.8511 19.4183 17.5448C20.1143 17.3175 20.5647 16.6455 20.5139 15.9106C20.4595 15.1229 19.8242 14.4876 19.0365 14.4332C18.1075 14.3676 17.324 15.0975 17.324 16.0264C17.324 16.6109 16.8503 17.0852 16.2652 17.0852C15.68 17.0852 15.2063 16.6109 15.2063 16.0264C15.2063 13.9384 16.9626 12.1688 19.1826 12.3205C21.0193 12.4476 22.5002 13.9285 22.6266 15.7652C22.7445 17.4685 21.6955 19.0285 20.0762 19.5579Z",
    fill: "#36827B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1071_2932"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0.921387)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzle);
export default __webpack_public_path__ + "static/media/puzzle.52d081fbcfead1e0c9718ef15e2767a7.svg";
export { ForwardRef as ReactComponent };